/**
 * @deprecated use CASStatus.name
 * @expires when Cert is removed from the database
 */
export enum CertStatus {
  RouterReview = 'Router Review',
  GroupReview = 'Group Review',
  REReview = 'RE Review',
  Revisions = 'Revisions Requested',
  Locked = 'Locked',
  Unlocked = 'Unlocked',
}

/**
 * @deprecated use CASStatus.priority
 * @expires when Cert is removed from the database
 */
export const CertStatusPriority = {
  [CertStatus.Revisions]: 0,
  [CertStatus.RouterReview]: 1,
  [CertStatus.GroupReview]: 2,
  [CertStatus.REReview]: 3,
  [CertStatus.Locked]: 4,
  [CertStatus.Unlocked]: 5,
} as const
